let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("oUCro")).then(() => parcelRequire('6luhh'));